


































































import Vue from "vue";
import vIcon from "@/components/v-components/v-icon.vue";
import { Fetch } from "@/plugins/fetch";
import { mapGetters } from "vuex";
import { testEmail } from "@/common/common";

export default Vue.extend({
  name: "RequestCustomerLink",
  components: {
    vIcon
  },
  data: () => {
    return {
      email: "" as string,
      status: "base" as string,
      errors: {
        email_missing: false,
        email_notValid: false
      } as { [key: string]: boolean }
    };
  },
  props: {
    initialEmail: {
      type: String,
      default: null
    }
  },
  computed: {
    ...mapGetters(["GET_CSRF_INFORMATION"])
  },
  methods: {
    preValidateFormData(): boolean {
      this.email = this.email.trim();
      Object.keys(this.errors).forEach(key => (this.errors[key] = false));
      !this.email && (this.errors.email_missing = true);
      !testEmail(this.email) && (this.errors.email_notValid = true);
      return Object.keys(this.errors).every(key => !this.errors[key]);
    },
    handleFormSubmit(): void {
      if (!this.preValidateFormData()) return;

      this.status = "loading";

      Fetch.post(
        `customer/requestcustomerlink?email=${this.email}&language=${this.$i18n.locale}`,
        this.GET_CSRF_INFORMATION.token
      )
        .then(() => {
          this.status = "done";
        })
        .catch(() => {
          this.status = "fail";
        });
    }
  },
  created() {
    if (this.$props.initialEmail) this.email = this.$props.initialEmail;
  }
});
